import React, { useContext } from "react";
import { Crosshair, Lightning } from "@phosphor-icons/react";
import { ModeContext, MODES } from "@/contexts/ModeContext";
import { AUREUS } from "@/constants/testIds";

export default function ModeToggle({ className = "" }) {
  const { mode, setMode } = useContext(ModeContext);
  const btn = (active) =>
    `inline-flex items-center gap-2 px-3 py-1.5 mono text-[11px] uppercase tracking-widest transition ` +
    (active
      ? "bg-gold text-black"
      : "text-zinc-400 hover:text-white");
  return (
    <div
      data-testid={AUREUS.modeToggle}
      className={`inline-flex items-center border border-white/10 bg-ink-800 ${className}`}
    >
      <button
        type="button"
        data-testid={AUREUS.modeToggleSnipe}
        onClick={() => setMode(MODES.SNIPE)}
        className={btn(mode === MODES.SNIPE)}
        aria-pressed={mode === MODES.SNIPE}
      >
        <Crosshair size={12} weight="bold" /> Trade Zone
      </button>
      <button
        type="button"
        data-testid={AUREUS.modeToggleScalp}
        onClick={() => setMode(MODES.SCALP)}
        className={btn(mode === MODES.SCALP)}
        aria-pressed={mode === MODES.SCALP}
      >
        <Lightning size={12} weight="bold" /> Short Zone
      </button>
    </div>
  );
}
